import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@qga/roo-ui/components';
import AppLink from 'components/AppLink';
import { useDataLayer } from 'hooks/useDataLayer';
import { useSelector } from 'react-redux';
import { getQueryString } from 'store/router/routerSelectors';

const StandardOfferMessage = ({ propertyId }) => {
  const { emitInteractionEvent } = useDataLayer();
  const propertyQueryString = useSelector(getQueryString);
  const propertyUrl = `/properties/${propertyId}/${propertyQueryString}`;

  const handleClick = useCallback(() => {
    emitInteractionEvent({ type: 'Standard Property Landing Page', value: `See all offers link Selected` });
  }, [emitInteractionEvent]);

  return (
    <Box pb={4} data-testid="standard-offer-message" pl={[4, 4, 0]}>
      <Text>
        Can’t find availability?
        <AppLink ml={1} textDecoration="underline" to={propertyUrl} onClick={handleClick} data-testid="standard-offers-link">
          See all offers
        </AppLink>
      </Text>
    </Box>
  );
};

StandardOfferMessage.propTypes = {
  propertyId: PropTypes.string.isRequired,
};

export default StandardOfferMessage;
